<div
    class="st-note-item-border-left"
    st-left-border
    [data]="note()"></div>
<div
    class="st-note-item__main"
    [class.st-note-item__main--expanded]="expanded()">
    <div class="st-note-item__header">
        @if (!expanded()) {
            <ng-container *ngTemplateOutlet="noteTimeUpdatedBy" />
        }
        <st-text-area-overlay
            class="st-note-item__header__text-area"
            minRows="1"
            minHeight="1rem"
            disableNewLine
            panelClass="st-note-item__header__text-area"
            [textToHighlight]="searchTerm()"
            [maxRows]="textMaxRows()"
            [value]="note()?.RawContent"
            [disabled]="disabled()"
            [placeholder]="languageSettings.PSTWebSlugPlaceholder" />
    </div>
    <div
        class="st-note-item__content"
        st-click-stop-propagation>
        @if (expanded()) {
            <ng-container *ngTemplateOutlet="noteTimeUpdatedBy" />
        }
        <st-status
            class="st-note-status__container__label"
            addEmptyOption
            [value]="note()?.PSTNoteStatus"
            [fieldName]="pstFieldNames.PSTNoteStatus"
            [disabled]="disabled()"
            [data]="note()"
            [itemType]="note()?.PSTNoteStatus?.id"
            [statusFieldName]="pstFieldNames.PSTNoteStatus"
            [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTNoteStatus]?.DefaultCaption"
            [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTNoteStatus)"
            (changed)="changeNoteStatus($event)" />
        <div
            class="st-note-item__content__options"
            st-click-stop-propagation>
            <button
                mat-icon-button
                class="st-note-item__content__options--expand-btn"
                [matTooltip]="expanded() ? languageSettings.PSTWebCollapseButtonLabel : languageSettings.PSTWebExpandButtonLabel"
                (click)="toggleExpandNote()">
                <mat-icon fontSet="material-symbols-outlined">
                    {{ expandNoteLabel() }}
                </mat-icon>
            </button>
            <st-external-actions-overlay
                st-click-stop-propagation
                isNoteItem
                [inFullScreen]="false"
                [inSidecarOpened]="true"
                [disabled]="disabled()"
                [data]="note()"
                [editable]="true" />
        </div>
    </div>
</div>
<ng-template #noteTimeUpdatedBy>
    <span class="st-note-item__time-and-updated-by">{{ timeUpdatedLabel() + updatedBy() }}</span>
</ng-template>
